export default {
  Home: 'Home',
  Mobile: 'Mobile',
  Work: 'Work',
  Fax: 'Fax',
  Other: 'Other',
  'Program TFN': 'Program TFN',
  Business: 'Business',
  Primary: 'Primary'
};
